export default {
    paymentStatement: [
        {
            a: '배달대행료',
            b: '200 건',
            c: '1,000,000 원',
        },
        {
            a: '보정',
            b: '200 건',
            c: '1,000,000 원',
        },
    ],
    deductionStatement: [
        {
            a: '수수료',
            b: '200 건',
            c: '1,000,000 원',
        },
        {
            a: '정기공제 (출근비)',
            b: '200 건',
            c: '1,000,000 원',
        },
        {
            a: '정기공제 (안심케어)',
            b: '200 건',
            c: '1,000,000 원',
        },
        {
            a: '정기공제 (바이크 리스비)',
            b: '200 건',
            c: '1,000,000 원',
        },
        {
            a: '정기공제(프로그램 사용료)',
            b: '200 건',
            c: '1,000,000 원',
        },
        {
            a: '정기공제 (기타)',
            b: '200 건',
            c: '1,000,000 원',
        },
        {
            a: '봉사료 수수료',
            b: '200 건',
            c: '1,000,000 원',
        },
        {
            a: '퀵 봉사료 수수료',
            b: '200 건',
            c: '1,000,000 원',
        },
        {
            a: '원천세 (소득세)',
            b: '200 건',
            c: '1,000,000 원',
        },
        {
            a: '보정',
            b: '200 건',
            c: '1,000,000 원',
        },
    ],
};
